var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',_vm._b({attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }